import WYSIWYG from '@components/ui/WYSIWYG'

interface Props {
  slice: any
}

const Content = ({ slice }: Props) => {
  return (
    <section className="content">
      {slice.primary.content && <WYSIWYG content={slice.primary.content} />}
      <style jsx global>
        {`
        .content h2 {
          font-size: 1.5rem;
          line-height: 2.1rem;
          --tw-text-opacity: 1;
          color: rgb(100 100 100 / var(--tw-text-opacity));
          margin-bottom: 1rem;
          font-weight:400;
        }
        .content h3 {
          font-size: 1.375rem;
          line-height: 1.925rem;
          --tw-text-opacity: 1;
          color: rgb(100 100 100 / var(--tw-text-opacity));
          margin-bottom: 1rem;
          font-weight:400;
        }
        .content h4 {
          font-size: 1.25rem;
          line-height: 1.75rem;
          --tw-text-opacity: 1;
          color: rgb(100 100 100 / var(--tw-text-opacity));
          margin-bottom: 1rem;
          font-weight:400;
        }
        .content p {
          margin-bottom: 10px;
          min-height:26px;
        }
        }
      `}
      </style>
    </section>
  )
}

export default Content
